<template>
  <a target="_blank" v-if="this.link" :href="this.href" :class="['clickable', {clickable__block: this.blockMode}, {clickable__alt: this.altMode}]">
    <slot></slot>
  </a>
  <router-link target="_blank" v-else-if="this.routerLink" :to="this.href" :class="['clickable', {clickable__block: this.blockMode}, {clickable__alt: this.altMode}]">
    <slot></slot>
  </router-link>
  <span v-else :class="['clickable', {clickable__block: this.blockMode}, {clickable__alt: this.altMode}]"><slot></slot></span>
</template>

<script>
export default {
  name: "Clickable",
  props: {
    link: Boolean,
    routerLink: Boolean,
    blockMode: Boolean,
    href: String,
    altMode: Boolean
  }
}
</script>

<style scoped lang="scss">
// Ссылка-действие: синий полужирный текст без подчёркивания, подчёркивание только при наведении
// (как названия в таблице «Подрядчики»).
.clickable {
  color: var(--ms-primary);
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.15s;

  &:hover {
    color: var(--ms-primary-hover);
    text-decoration: underline;
  }

  &__block {
    display: block;
  }

  &__alt {
    font-weight: 500;
  }
}
</style>
